<script>
	import Button from '../Button/Button.svelte';

	export let caption = '';
	export let href = '';
	export let label = '';
	/** @type {import('@resider/types').Sizing} */
	export let size = 'md';
</script>

<div class="cta-with-caption {size}">
	<slot name="cta">
		<Button {size} {href} on:click>
			{label}
		</Button>
	</slot>

	<slot name="caption">
		<span class="caption">
			{@html caption}
		</span>
	</slot>
</div>

<style>.cta-with-caption{display:grid;grid-gap:.75rem;gap:.75rem;align-items:center;justify-items:center;place-items:center}.caption{text-align:center;color:hsla(var(--hsl-gray))}.sm .caption{font:var(--f-ui-xs-semibold)}.md .caption{font:var(--f-ui-sm-semibold)}.lg .caption{font:var(--f-ui-md-semibold)}</style>
